// extracted by mini-css-extract-plugin
export default {"title":"a6-z","warning":"b6-z","sizeOptionsLegendText":"c6-z"};